import { defineAsyncComponent } from 'vue';

export default function (app) {
    app.component('HomeItem', defineAsyncComponent(() => import('@/components/HomeItem.vue')));
    app.component('LanguageSwitcher', defineAsyncComponent(() => import('@/components/LanguageSwitcher.vue')));
    app.component('AppBar', defineAsyncComponent(() => import('@/components/AppBar.vue')));
    app.component('AppFooter', defineAsyncComponent(() => import('@/components/AppFooter.vue')));

    // Form components
    app.component('location-input', defineAsyncComponent(() => import('@/components/GMapsAutoCompleteInput.vue')));
    app.component('birthday-input', defineAsyncComponent(() => import('@/components/BirthdayInput.vue')));
    app.component('google-auto-address', defineAsyncComponent(() => import('@/components/GoogleAutoAddress.vue')));
    app.component('switch', defineAsyncComponent(() => import('@/components/Switch.vue')));
    app.component('customer-checkout', defineAsyncComponent(() => import('@/components/CustomerCheckout.vue')));
    app.component('order-method-changer', defineAsyncComponent(() => import('@/components/OrderMethodChanger.vue')));
    app.component('invoice-checkout', defineAsyncComponent(() => import('@/components/InvoiceCheckout.vue')));
    app.component('geolocate', defineAsyncComponent(() => import('@/components/Geolocate.vue')));
}
